<script>

    import { Beep  } from "../../App.svelte";
    import { createEventDispatcher, onMount } from "svelte";
    import { TimerWorker } from "../../worker/index";
    import { showNotification } from "../../notification";
    import {
        User,
        SiteSettings,
        BetSettingsLocal,
        ApStatsLocal,
        CurrencyConversionRates,
        BetsHistory,
        BetList,
        ChatMessages,
        ApiKey,
        Mirror,
    } from "../../stores";

    import { BetConfigContainer } from "./index";
    import { BetItem, BetsList } from "../betlist/index";

    import {
        default as GameComps,
        VideoPokerBet,
        VideoPokerStrategies,
    } from "./games";

    import {
        Icon,
        Input,
        Checkbox,
        Dropdown,
        Button,
        Buttons,
        Segments,
        Segment,
        Grid,
        Row,
        Column,
        Statistic,
        Label,
        Text,
        Rail,
        Sidebar,
    } from "svantic";

    import { postData, wait, css, onInterval } from "../../scripts/utils";

    import {
        APIQueries,
        createMyBetListQuery,
        createBetQuery,
        createUserDataQuery,
        createStakeWsClient,
        ChatMessagesQuery,
        createBet,
        createBetWs,
        subscribeHouseBets,
ChatEddieCheckQuery,
        
    } from "../../scripts/stake-api";
import { currencyValue } from "../balance";

    ////////
    // log stores
    // console.log("$User", () => $User)
    // console.log("$ApStatsLocal", () => $ApStatsLocal, "\n\t update: ", ApStatsLocal.update)


    let siteConfig = $SiteSettings;

    SiteSettings.subscribe((store) => {
        siteConfig = store;
    });

    let _game;
    export { _game as game };

    let form_betconfig;

    let lastBet;
    let _betList = [];

    let StopConditions = new Set();
    console.log("[DEBUG] StopConditions Set: ", StopConditions);
    let stopConditions = [];
    let i_stopOnPayoutMultiplier = 2;

    let i_diamonds_result = "";
    let i_dice_result = ""
  
    let i_videopoker_result = "";
    let i_videopoker_result_card = "A";
    let lastBetResult = 0;

    let isLoading = false;

    let i_delay = 150;
    let bets_per_second = 0;

    $: i_delay = !i_delay || i_delay < 0 ? 50 : parseInt(i_delay);

    onMount(() => {
        console.log("gamecontainer onMount");

        console.log(" > create StakeWsClient");
        createWsClient();

        const unsubscribe_betList = BetList.subscribe((list) => {
            _betList = list.slice(-200);
        });

        const unsubscribe = BetsHistory.subscribe((list) => {
            lastBet = list.length > 0 ? list[list.length - 1] : [];
        });

        return () => {
            unsubscribe();
            unsubscribe_betList();
            if(interval_h)
                interval_h()
        };
    });

    const requestBetList = (limit, offset, game) => {
        postData(
            APIUrl,
            createMyBetListQuery(limit, offset, game),
            API_reqConfig
        ).then((data) => {
            console.log("response data: ");
            console.log(data);
        });
    };

    let Game;
    let placeBet;
    $: {
        if (Game) {
            placeBet = Game.placeBet;
            form_betconfig.setBetAmount(0.0);
        }
    }

    let autobet = false;

    const startAutoBet = async () => {        
        console.log("AutoBet start ");

        let start = Date.now();
        let elapsed = 0;
        let pending = 0;
        const max_pending = 10;
        let bets = 0;
        let wager = 0;
        let profit = 0;

        $ApStatsLocal.session = {
            bets,
            profit,
            wager,
            currency: $BetSettingsLocal.currency,
        };

        const MultiStageGames = ["hilo", "videopoker", "samurai"];
        let autobet_config = {};

        const updateConfig = () => {
            return {
                game: _game,
                variables: {
                    multiplierTarget: $BetSettingsLocal.multiplierTarget,
                    condition: $BetSettingsLocal.condition,
                    target: $BetSettingsLocal.target,
                    lines: $BetSettingsLocal.lines,
                    minesCount: $BetSettingsLocal.minesCount,
                    fields: $BetSettingsLocal.fields,
                    rows: $BetSettingsLocal.rows,
                    risk: $BetSettingsLocal.risk,
                    difficulty: $BetSettingsLocal.difficulty,
                    eggs: $BetSettingsLocal.eggs,
                    amount: $BetSettingsLocal.amount,
                    numbers: $BetSettingsLocal.numbers,
                    currency: $BetSettingsLocal.currency,
                    segments: $BetSettingsLocal.segments,
                },
            };
        };

        const updateStats = (_currency, _amount, _profit) => {
            bets += 1;
            wager += _amount;
            profit += _profit;

            $ApStatsLocal.session.bets++;
            $ApStatsLocal.session.profit += _profit;
            $ApStatsLocal.session.wager += _amount;

            $ApStatsLocal[_currency].bets++;
            $ApStatsLocal[_currency].profit += _profit;
            $ApStatsLocal[_currency].wager += _amount;
        };

        const checkStopConditions = (bet) => {
            let tmp = autobet;

            // check stop conditions
            if (StopConditions.has("stopOnWin") && bet.payoutMultiplier > 0) {
                // && res[0].payoutMultiplier > 0
                autobet = false;
            }

            if (StopConditions.has("stopOnPayoutMultiplier")) {
                if (   bet.payoutMultiplier >= i_stopOnPayoutMultiplier ||  (_game == "limbo" &&  bet.result.result >= i_stopOnPayoutMultiplier)  )
                    autobet = false;
            }

            if ( StopConditions.has("diamonds_matchResult") &&  _game == "diamonds" ) {
                let matchResult = i_diamonds_result
                    .toLocaleLowerCase()
                    .replaceAll("pink", "orange")
                    .replaceAll(" ", "")
                    .split(",")
                    .join(""); //["green", "green", "green", "green", "green"]
                let hand = bet.result.result.join("").toLowerCase();

                if (hand == matchResult) {
                    console.log("diamonds match found! ");
                    console.table(bet);

                    autobet = false;
                }
            }

            if ( StopConditions.has("dice_matchResult") &&  (_game == "dice"  || _game == "limbo" )) {
                if (bet.result.result == i_dice_result)
                    autobet = false;
            }

            if ( StopConditions.has("videopoker_matchResult") &&  _game == "videopoker" ) {
                if (bet.state.handResult == i_videopoker_result)
                    autobet = false;
            }

            if (siteConfig.notifications === true && tmp !== autobet)
                showNotification("Stake Bot", "hit!", true);
        };
        
        while (autobet) {
            //let _t = Date.now();

            autobet_config = updateConfig();

            if (!MultiStageGames.includes(autobet_config.game)) {
                if (pending < max_pending) {
                    Game.placeBet(autobet_config).then((res) => {
                        --pending;

                        if (res.error || !res.data) {
                            return;
                        }

                        updateStats(
                            res.data.currency,
                            res.data.amount,
                            res.data.payout - res.data.amount
                        );

                        //elapsed = Date.now() - _t;
                        bets_per_second = parseFloat(
                            bets / ((Date.now() - start) / 1000)
                        ).toFixed(2);

                        checkStopConditions(res.data);
                    });

                    pending++;
                } else {
                    console.log("skip bet (pending " + pending + ")");
                }
                // await TimerWorker.wait((i_delay >= 50) ? i_delay : 50)
            } else {
                let bet;

                switch (autobet_config.game) {
                    case "videopoker":
                        bet = new VideoPokerBet();
                        await bet.bet(autobet_config.variables);

                        break;
                    case "samurai":
                        bet = await Game.placeBet(autobet_config.variables);
                        break;
                }

                while (bet.data.active) {
                    if (autobet_config.game == "videopoker") {
                        let [err, res] = await bet.runStrategy({
                            fnc: VideoPokerStrategies["fourOfKind"].fnc,
                            details: { rank: i_videopoker_result_card },
                        });
                    } else if (autobet_config.game == "samurai") {
                        await Game.next();
                        await TimerWorker.wait(25);
                    }
                }

                if (bet?.data?.id) {
                    bets_per_second = parseFloat(
                        bets / ((Date.now() - start) / 1000)
                    ).toFixed(2);

                    updateStats(
                        bet.data.currency,
                        bet.data.amount,
                        bet.data.payout - bet.data.amount
                    );
                    checkStopConditions(bet.data);
                }
            }

            await TimerWorker.wait(
                (i_delay >= 20 ? i_delay : 20) + (Math.random() * 10)
            );
        }

        console.log("autobet stopped, bets: ", bets);
        console.log(
            "wager: ",
            wager + " " + $BetSettingsLocal.currency.toUpperCase()
        );
    };

    const toogleAutoBet = async () => {
        if (autobet) {
            autobet = false;
            return;
        } else {
            autobet = true;

            startAutoBet();
        }
    };

    const stopAutobet = () => {
        if (autobet) {
            autobet = false;

            return;
        }
    };
    let gqlws;
    const createWsClient = async (apikey) => {
        console.log("createStakeWsClient");
        if (!apikey || apikey.length < 10) {
            console.log("e: fnc createWsClient, provide a valid key ");
            return;
        }
        if (gqlws) await gqlws.dispose();

        gqlws = await createStakeWsClient(apikey);


        gqlws.emitter.on("gqlws error", (err) => {
            console.log("[err] gqlws client on 'gqlws error'!");
            console.error(err);
        });

        gqlws.emitter.on("logged in", () => {
            console.log(
                "gqlws client on 'logged in'. start 'conversion rates update' interval, subscribe to houseBets ..."
            );

            subscribeHouseBets(_game);
        });

        gqlws.emitter.on("invalid apikey", () => {
            console.log("gqlws client on 'invlid apikey'!");
            $ApiKey = "";

            alert("error on login: invalid api key.");
        });

        function chatLog(room, user, msg) {
            console.log(`chat[${room}] \n\t ${user}: ${msg} \n`);
        }

        // listener for formatted subscriptions data
        gqlws.emitter.on("houseBets", (bet) => {
            //console.log("gqlws.emitter on 'houseBets'", bet)
            // add bet result to BetsHistory store
            BetsHistory.append([...bet]);
        });

        /*
        gqlws.wsSubscribe(ChatMessagesQuery("challenges"), (res) => {
          
            ChatMessages["challenges"].append(res.data.chatMessages)
        })
        */

        
        const reg_names = /daxtaa|RealCoinMarcel|Dogecoinbrot|brothernero/i
        const reg_message = /(roll|hunt|rollhunt|hitte)/i
/*
        gqlws.wsSubscribe(ChatEddieCheckQuery("en"), (res) => {  
            if(res.data.chatMessages?.data?.rain){
                let d = res.data.chatMessages.data.rain
                console.log("[EN] rain: \n\t giver: ", d.giver.name, " amount:", d.amount, "currency: ", d.currency )

                if(d.giver.name.toLowerCase() == "eddie")
                    Beep(500, 130, 5)
                
                 
            }

        })
        */
       
        gqlws.wsSubscribe(ChatMessagesQuery("de"), (res) => {  
            if( reg_names.test( res.data.chatMessages.user.name ) ){

                // check for roll hunt message
               if( reg_message.test(res.data.chatMessages.data.message) )
                    Beep(250, 28, 30)


                console.log("[DE]", res.data.chatMessages.user.name, res.data.chatMessages.data.message)
            }

            if(res.data.chatMessages?.data?.rain){
                let d = res.data.chatMessages.data.rain
                console.log("[DE] rain: \n\t giver: ", d.giver.name, " amount:", d.amount, "currency: ", d.currency )
            }

          //  ChatMessages["de"].append(res.data.chatMessages)
        })

    
        
        
    };

    //$: createWsClient($ApiKey);
    $: if ($ApiKey || $Mirror) createWsClient($ApiKey);

    function handleClick(ev, action, config = {}) {
        switch (action) {
            case "getBetList":
                requestBetList(20, 0, "limbo");
                break;

            case "placeBet":
                placeBet(config);
                break;
            case "toogleAutoBet":
                toogleAutoBet();
                break;
            case "getBetConfig":
                console.log(form_betconfig.getBetConfig());
                break;
            case "WsClient":
                createWsClient();
                break;
        }
    }

    $: if (gqlws) {
        subscribeHouseBets(_game);
    }
</script>

<Segment style={{ "background-color": "#181818" }} raised attached="top">
    <Segment basic aligned="center" fitted>
        <svelte:component
            this={GameComps[_game] ? GameComps[_game].display : null}
            bind:this={Game} />
    </Segment>
</Segment>
<Segment raised="true" padded attached>
    <BetConfigContainer bind:this={form_betconfig} game={_game} let:BetConfig />
</Segment>

<Segment fitted="horizontally" raised attached>
    <div class="flex-container">
        <div class="f-item  f-2">
            <Button
                color={!autobet ? "green" : "red"}
                icon={!autobet ? "play" : "stop"}
                on:click={(ev) => {
                    ev.stopPropagation();
                    handleClick(ev, "toogleAutoBet");
                }}>
                {!autobet ? "Start" : "Stop"}
            </Button>

            <Input
                type="number"
                min="50"
                max="5000"
                step="10"
                bind:value={i_delay}
                labeled="right"
                color="blue"
                size="small">
                <Label>delay ms</Label>
            </Input>
        </div>
        <div class="f-item">
            <p><b>Bets/s</b>: {bets_per_second}</p>
            <p><b>Bets</b>: {$ApStatsLocal.session.bets}</p>
        </div>

        <div class="f-item">
            <b>Wager</b>: {$ApStatsLocal.session.wager.toFixed(8)}
            {$ApStatsLocal.session.currency.toUpperCase()}
            <p style="text-align: center; font-size: small;">
                {currencyValue($ApStatsLocal.session.currency, $ApStatsLocal.session.wager, "usd")} $
            </p>
        </div>
        <div class="f-item">
            <b>Profit</b>: {$ApStatsLocal.session.profit.toFixed(8)}
            {$ApStatsLocal.session.currency.toUpperCase()}
            <p style="text-align: center; font-size: small;">
                    {currencyValue($ApStatsLocal.session.currency, $ApStatsLocal.session.profit, "usd")} $
            </p>
        </div>
    </div>
</Segment>

<Segment fitted="vertically" raised attached color="yellow">
    <Segments attached type="horizontal equal width">
        <Segment basic compact>
            <p>stop conditions</p>
            <div>
                <Checkbox
                    size="small"
                    labeled="right"
                    id="check_stopOnWin"
                    settings={{
                        fireOnInit: true,
                        onChecked: () => {
                            StopConditions.add("stopOnWin");
                        },
                        onUnchecked: () => {
                            StopConditions.delete("stopOnWin");
                        },
                    }}>
                    <label for="check_stopOnWin"> on win</label>
                </Checkbox>
            </div>
            <div>
                <Checkbox
                    size="small"
                    labeled="right"
                    id="check_stopPayoutMultiplier"
                    settings={{
                        fireOnInit: true,
                        onChecked: () => {
                            StopConditions.add("stopOnPayoutMultiplier");
                        },
                        onUnchecked: () => {
                            StopConditions.delete("stopOnPayoutMultiplier");
                        },
                    }}>
                    <label for="check_stopPayoutMultiplier">
                        on payout multi
                    </label>
                </Checkbox>
                <Input
                    size="small"
                    class="padding-inline"
                    type="number"
                    min="1.01"
                    step="1"
                    bind:value={i_stopOnPayoutMultiplier} />
            </div>
        </Segment>
        <Segment basic compact>
            <p />

            {#if _game == "dice" || _game == "limbo"}
                <div>
                    <Checkbox
                        id="check_diceResult"
                        settings={{
                            fireOnInit: true,
                            onChecked: () => {
                                StopConditions.add("dice_matchResult");
                            },
                            onUnchecked: () => {
                                StopConditions.delete("dice_matchResult");
                            },
                        }}
                        size="small"
                        labeled="right">
                        <label for="check_diceResult"> result match </label>
                    </Checkbox>
                    <Input
                        size="small"
                        class="padding-inline"
                        type="number"
                        min="0.00"
                        bind:value={i_dice_result}
                        placeholder="... 33.77" />
                </div>
            {/if}
            {#if _game == "diamonds"}
                <div>
                    <Checkbox
                        id="check_diamondsResult"
                        settings={{
                            fireOnInit: true,
                            onChecked: () => {
                                StopConditions.add("diamonds_matchResult");
                            },
                            onUnchecked: () => {
                                StopConditions.delete("diamonds_matchResult");
                            },
                        }}
                        size="small"
                        labeled="right">
                        <label for="check_diamondsResult"> result match </label>
                    </Checkbox>
                    <Input
                        size="small"
                        class="padding-inline"
                        type="text"
                        bind:value={i_diamonds_result}
                        placeholder="red,red,yellow,yellow,blue" />
                </div>
            {/if}
            {#if _game == "videopoker"}
                <div>
                    <Checkbox
                        id="check_videopokerResult"
                        settings={{
                            fireOnInit: true,
                            onChecked: () => {
                                StopConditions.add("videopoker_matchResult");
                            },
                            onUnchecked: () => {
                                StopConditions.delete("videopoker_matchResult");
                            },
                        }}
                        size="small"
                        labeled="right">
                        <label for="check_videopokerResult">
                            video poker result
                        </label>
                    </Checkbox>
                    <div>
                        <Dropdown
                            selection
                            size="mini"
                            class="padding-inline"
                            style={{
                                "max-width": "120px",
                                "margin-left": "12px",
                            }}
                            settings={{
                                onChange: (value, text, $selectedItem) => {
                                    i_videopoker_result = text;
                                },
                            }}>
                            <input name="videopoker_match" type="hidden" />
                            <Dropdown.Text>Select Result</Dropdown.Text>
                            <i class="ui dropdown icon" />
                            <Dropdown.Menu>
                                <Dropdown.Item selected data-value="fourOfAKind">fourOfAKind</Dropdown.Item>
                                <Dropdown.Item data-value="fullHouse" >fullHouse</Dropdown.Item>
                                <Dropdown.Item data-value="royalFlush" >royalFlush</Dropdown.Item>
                                <Dropdown.Item data-value="straightFlush" >straightFlush</Dropdown.Item>
                                <Dropdown.Item data-value="flush">flush</Dropdown.Item>
                                <Dropdown.Item data-value="straight">straight</Dropdown.Item>
                                <Dropdown.Item data-value="threeOfAKind" >threeOfAKind</Dropdown.Item>
                                <Dropdown.Item data-value="twoPair" >twoPair</Dropdown.Item>
                                <Dropdown.Item data-value="onePair">onePair</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    {#if i_videopoker_result == "fourOfAKind"}
                        <div>
                                <Dropdown
                                selection
                                size="mini"
                                class="padding-inline"
                                style={{ "min-width": "34px", "margin-left": "12px", }}
                                settings={{
                                    onChange: (value, text, $selectedItem) => {
                                        i_videopoker_result_card =
                                            value.toUpperCase(); // custom action
                                    },
                                }}>
                                <input
                                    name="videopoker_result_card"
                                    type="hidden"
                                    value={i_videopoker_result_card} />
                                <Dropdown.Text>rank</Dropdown.Text>
                                <Dropdown.Menu>
                                    {#each ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"] as rank}
                                        <Dropdown.Item value={rank}
                                            >{rank}</Dropdown.Item>
                                    {/each}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    {/if}
                </div>
            {/if}
        </Segment>
    </Segments>
</Segment>

<Segment inverted attached raised>
    <Segment basic fitted attached>
        <div class="betlistContainer">
            <BetsList items={_betList} />

            <!--
        <BetsTable rows={$BetsHistory}></BetsTable> 
         -->
        </div>
    </Segment>
</Segment>

<style>
    .flex-container {
        display: flex;
    }

    .flex-container > .f-item {
        flex: 1;
    }

    .f-2 {
        flex: 2 0 2;
    }

    .padding-inline {
        padding-inline: 8px;
    }
</style>
